<template>
  <div class="entity-details-layout entity-details-layout-list">
    <icon-in-circle class="entity-details-icon">
      <font-awesome-icon icon="history"/>
    </icon-in-circle>
    <div class="entity-details-header pv3 pv4-l ph3 ph1-l">
      <span class="db ttu f6 fw6 entity-secondary">История изменения статусов</span>
    </div>
    <div class="entity-details-content list-grid ml4-l bt b--near-white bw1">
      <journal-list-item v-for="(item, index) in claim.status_history" :key="index" :item="item" :showClaim="false" />
    </div>
  </div>
</template>

<script>
import IconInCircle from '@/components/ui/IconInCircle.vue'
import JournalListItem from '@/components/claims/JournalListItem.vue'

export default {
  props: ['claim'],
  components: {
    IconInCircle,
    JournalListItem
  }
}
</script>

<style lang="scss" scoped>
</style>
